import { objectTypes } from "src/consts/objectTypes";
import CreateInspectionForm from "src/components/Forms/CreateInspectionForm";
import { lang } from "src/language/Strings";
import FileInput from "src/components/FileInput";
import { InspectionResponse, SasFileResult } from "src/types/InspectionUpdateRequest";
import { useEffect, useMemo, useState } from "react";
import Toggle, { ToggleCss } from "src/components/Toggle";
import "./CreateEgenkontroll.css";
import useProjectVariations from "src/api/hooks/useProjectVariations";
import { payloadType } from "src/types/InspectionPayloadType";
import { usePosition } from "src/api/hooks/usePosition";
import useMyUser from "src/api/hooks/useMyUser";
import { useNavigate, useParams } from "react-router-dom";
import { LocalStorageKeys } from "src/utils/localStorageKeys";
import useCreateVariation from "src/api/hooks/useCreateVariation";
import { Spinner } from "src/components/LoadingSpinner";
import { routes } from "src/routes";
import { ShowToast } from "src/components/Toast";
import AutoCompleteTextField from "src/components/AutoCompleteTextField";
import { InputLabel } from "@mui/material";
import { useStore } from "src/components/Store";

function createDatalistItems(inspections: InspectionResponse[], key: string ) {
  return inspections.reduce((acc: string[], inspection) => {
    if (inspection[key as keyof InspectionResponse] && !acc.includes(inspection[key as keyof InspectionResponse] as string)) {
      acc.push(inspection[key as keyof InspectionResponse] as string);
    }
    return acc;
  }, [] as string[]).map((item) => (
    <option key={item} value={item} />
  ));
}
export default function CreateEgenkontroll() {
  const [files, setFiles] = useState<SasFileResult[]>([]);
  const { data: inspections } = useProjectVariations();
  const position = usePosition();
  const { companyId } = useParams();
  const createMutation = useCreateVariation();
  const { data: myUser } = useMyUser();
  const store = useStore();

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
      e.preventDefault();
      const form = e.target as HTMLFormElement;
      
      // Check form validity before proceeding
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());
      const payload: payloadType = {
        companyId: Number(companyId),
        userId: myUser?.id,
        groupId: myUser?.groups?.[0]?.id || Number(localStorage.getItem(LocalStorageKeys.groupId)) || 0,
        latitude: position.latitude,
        longitude: position.longitude,
        deviationType: 1,
        objectType: objectTypes.Inspection,
        title: data.title as string,
        externalId: store.externalObjectId ? store.externalObjectId : "",
        customer: data.customer as string,
        information: data.information as string,
        files: files.map((file) => ({...file, groupId: groupId})),
        positionRequest: {
          latitude: position.latitude,
          longitude: position.longitude,
          geometry: `{"type":"Point","coordinates":[${position.longitude},${position.latitude}], "properties": {
          "objectType": "Inspection",
          "markerColor": "#0000DD",
          "geometryType": "Point"
          }}`,
          adress: data.title as string,
        },
        description: data.comment as string,
        status: data.completed === "on" ? "5" : "1",
      }
    
      createMutation.mutate(payload);
  }
  const groupId = useMemo(() => {
    return myUser?.groups?.[0]?.id || Number(localStorage.getItem(LocalStorageKeys.groupId)) || 0
  },[myUser, localStorage.getItem(LocalStorageKeys.groupId)])
  const navigate = useNavigate();
  useEffect(() => { 
    if (createMutation.status === "success") {
      ShowToast(lang.inspectionCreated || "", "success", 3000);
      navigate(routes.Egenkontroller.Pages.Show.url(Number(companyId)!, createMutation.data.id!));
    }
    if (createMutation.status === "error") {
      ShowToast(lang.errorCreatingInspection, "error", 3000);
    }
  },[createMutation.status, companyId, navigate])

  return (<>
      {createMutation.status === "pending" && <div className="flex justify-center mt-4"><Spinner /></div>}
      {createMutation.status === "error" && <div className="flex justify-center mt-4"><p className="text-PrimaryRed">{createMutation.error.message}</p></div>}
      <form id="inspection-form" onSubmit={(e) => {
        handleSubmit(e);
      }}>

      {companyId !== "12" && <div className="form-group">
        <AutoCompleteTextField name="title" field="title" label={lang.address} required={true}/>
      </div>}

      {companyId !== "12" && <div className="form-group">
        <AutoCompleteTextField name="customer" field="customer" label={lang.customer} required={true} />
      </div>}
      <div className="form-group">
        <AutoCompleteTextField name="information" field="information" label={companyId !== "12" ? lang.information : lang.skotselKod} required={true} defaultValue={store.defaultInspectionComment ? store.defaultInspectionComment : ""} />
      </div>
      <div className="form-group">
      <InputLabel htmlFor="comment">{lang.comment}:</InputLabel>
      <textarea rows={4} id="comment" name="comment" className="" />
      </div>  
      <div className="form-group">
      <InputLabel htmlFor="files">{lang.addImages}:</InputLabel>
      <FileInput
      groupId={groupId}
      name="files"
      required
      multiple
      onChange={((files) => {
        setFiles(files);
      })}
      />
      </div>
      <div className="form-group">
        <Switch name="completed" defaultValue={false} />
        </div>
      <div className="flex justify-center mt-4">
      <button type="submit" className="bg-PrimaryBlue text-White rounded-lg pt-2 pb-2 px-4">{lang.save}</button>
      </div>
      </form>
    </>)
}

function Switch({name, defaultValue}: {name: string, defaultValue: boolean}) {
  const [checkedText, setCheckedText] = useState(defaultValue ? lang.completed : lang.notCompleted);
  return <div className="flex flex-row gap-2"><label className="switch">
  <input id={`switch-checkbox-${name}`} type="checkbox" name={name} defaultChecked={defaultValue} onChange={(e) => {
    console.log(" Checked: ",e.target.checked);
    if (e.target.checked) {
      setCheckedText(lang.completed);
    } else {
      setCheckedText(lang.notCompleted);
    }
  }} />
  <span className="slider round"></span>
  
</label>
<span>{checkedText}</span>
</div>
}